import styled from '@emotion/styled';
import React from 'react';
import { CheckmarkIconWhite } from 'icons';
import { LatanaText } from 'common/components/LatanaText';

export const CheckboxListItemContainer = styled.div<{ toggleEnabled?: boolean; spaceBetween: boolean }>`
  width: 100%;
  cursor: pointer;
  position: relative;
  padding: 4px 0;
  display: flex;
  align-items: center;
  justify-content: ${({ spaceBetween }) => (spaceBetween ? 'space-between' : 'flex-start')};
  border-top: 1px solid ${({ theme }) => theme.colors.gray100.toString()};
`;

export const CheckboxCircle = styled.input<{ checked?: boolean }>`
  /* removing default appearance */
  -webkit-appearance: none;
  appearance: none;
  position: relative;
  width: 16px;
  height: 16px;
  background-color: ${({ theme }) => theme.colors.white.toString()};
  border-radius: 50%;
  margin: ${({ theme }) => theme.space(1, 2)};
  border: 1px solid ${({ theme }) => theme.colors.gray400.toString()};
  outline: none;
  cursor: pointer;

  &:checked {
    transition: background 0.2s ease-in-out;
    background: ${({ theme }) => theme.colors.lightPurple.toString()};
    color: ${({ theme }) => theme.colors.white.toString()};
    border: none;

    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-image: url(${CheckmarkIconWhite});
      background-size: 8px 8px;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
`;

const InnerWrapper = styled.div<{ reverseOrder?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${({ reverseOrder }) => (reverseOrder ? '100%' : 'auto')};
  flex-direction: ${({ reverseOrder }) => (reverseOrder ? 'row-reverse' : 'row')};
  padding: ${({ reverseOrder, theme }) => (reverseOrder ? theme.space(0, 0, 0, 0.5) : 0)};
`;

interface Props<T extends string | number = string> {
  value: T;
  label?: string;
  checked?: boolean;
  spaceBetween?: boolean;
  reverseOrder?: boolean;
  renderChild?: () => JSX.Element;
  onCheck?: (value: T, checked: boolean) => void;
}

const CheckboxListItem: React.FC<Props> = ({ value, onCheck, checked, label, renderChild, spaceBetween = false, reverseOrder = false }) => {
  return (
    <CheckboxListItemContainer toggleEnabled={checked} spaceBetween={spaceBetween}>
      <InnerWrapper onClick={() => onCheck?.(value, !checked)} reverseOrder={reverseOrder}>
        <CheckboxCircle value={value} checked={checked} type='checkbox' readOnly />
        <LatanaText color='gray900' variant='L1' fontWeight='500'>
          {label}
        </LatanaText>
      </InnerWrapper>
      {renderChild?.()}
    </CheckboxListItemContainer>
  );
};

export default CheckboxListItem;
